import React, { useState, useMemo } from "react";
import { Stack, Group, Title, TextInput } from "@mantine/core";
import { debounce } from "lodash";
import { IconSearch } from "@tabler/icons-react";
import { router } from "@inertiajs/react";
import VehicleList from "../shared/components/VehicleList";
import { AdminVehiclesIndexProps } from "../VehicleVersion/types";

const AdminVehiclesIndex: React.FC<AdminVehiclesIndexProps> = (props) => {
  const { title, vehicles, pagination, search } = props;

  const [searchValue, setSearchValue] = useState(search);

  const debouncedSearch = useMemo(
    () =>
      debounce((value: string) => {
        router.get(
          "/admin/vehicles",
          { search: value, page: 1, per_page: pagination.per_page },
          { preserveState: true, preserveScroll: true },
        );
      }, 300),
    [],
  );

  const handleSearch = (value: string) => {
    setSearchValue(value);
    debouncedSearch(value);
  };

  const onPaginationChange = (page: number, perPage: number) => {
    router.get("/admin/vehicles", {
      search: searchValue,
      page,
      per_page: perPage,
    });
  };

  return (
    <Stack gap="md">
      <Group justify="space-between" align="center">
        <Title order={2}>{title}</Title>
        <TextInput
          placeholder="Rechercher un modèle…"
          leftSection={<IconSearch size={16} />}
          value={searchValue}
          onChange={(e) => handleSearch(e.currentTarget.value)}
          w={260}
        />
      </Group>
      <VehicleList
        vehicles={vehicles}
        pagination={pagination}
        onPaginationChange={onPaginationChange}
        onRowClick={(record) =>
          router.visit(`/admin/vehicles/${record.id}/edit`)
        }
      />
    </Stack>
  );
};

export default AdminVehiclesIndex;
